import React from 'react';
import { FaFolder, FaRobot, FaGithub } from 'react-icons/fa';
import '../../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-branding">
          <FaFolder className="footer-icon" />
          <p>&copy; {new Date().getFullYear()} MMF File Organizer</p>
        </div>
        <div className="footer-info">
          <p className="ai-powered">
            <FaRobot className="ai-icon" /> AI-Powered File Organization
          </p>
        </div>
        <div className="footer-links">
          <a href="https://github.com/your-repo/mmf-organizer" target="_blank" rel="noopener noreferrer">
            <FaGithub /> GitHub
          </a>
          <a href="https://myminifactory.com" target="_blank" rel="noopener noreferrer">MyMiniFactory</a>
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;